module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_9.d2681fcc.jpg";